export default {
  state: {
    ProductsLimit: 15, //15
  },
  mutations: {
    SetProductsLimit(state, payload) {
      state.ProductsLimit += payload;
    },
  },
  actions: {
    AddProductsLimit({ commit }, payload) {
      commit("SetProductsLimit", payload);
    },
  },
  getters: {
    getProductsLimit: (state) => state.ProductsLimit,
  },
};
